module.exports = __webpack_public_path__ + "img/modelzh_8.6f65218b.png";